import {
  LOGIN_USER_ERROR,
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESSFUL,
  LOGOUT_USER,
  UserActions,
  LOGIN_CLEAN,
  GET_USER_BY_ID,
  SIGNUP_USER_SUCCESSFUL,
  SIGNUP_USER_REQUEST,
  SEND_CODE_REQUEST,
  SEND_CODE_SUCCESSFUL,
  SEND_CODE_ERROR,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESSFUL,
  RESET_PASSWORD_ERROR,
  SIGNUP_USER_ERROR,
  USER_REQUEST,
  USER_RESPONSE,
} from './user.action.type';
import { UserState } from './user.types';

const defaultState: UserState = {
  user: {
    email: null,
  },
  userData: {
    id: '',
    permissions: {},
    email: '',
    isFetching: false,
  },
  error: null,
  isFetching: false,
  isSuccessful: false,
  authenticated: false,
};

export default (state = defaultState, action: UserActions): UserState => {
  switch (action.type) {
    case USER_REQUEST: {
      return {
        userData: {
          ...action.payload,
        },
        authenticated: true,
        isFetching: true,
      };
    }
    case USER_RESPONSE: {
      return {
        userData: {
          ...action.payload,
        },
        authenticated: true,
        isFetching: false,
      };
    }
    case LOGIN_USER_REQUEST: {
      return {
        user: {
          ...action.payload,
        },
        authenticated: false,
        isFetching: true,
      };
    }
    case LOGIN_CLEAN: {
      return {
        ...action.payload,
      };
    }
    case LOGIN_USER_SUCCESSFUL: {
      return {
        user: {
          ...action.payload,
        },
        authenticated: true,
        isFetching: false,
      };
    }
    case LOGIN_USER_ERROR: {
      return {
        authenticated: false,
        isFetching: false,
        error: action.error,
      };
    }
    case LOGOUT_USER:
      return {
        authenticated: false,
        isFetching: false,
        user: undefined,
      };
    case GET_USER_BY_ID: {
      return {
        user: {
          ...action.payload,
        },
        authenticated: true,
        isFetching: false,
      };
    }
    case SIGNUP_USER_REQUEST: {
      return {
        authenticated: false,
        isFetching: true,
      };
    }
    case SIGNUP_USER_SUCCESSFUL: {
      return {
        isFetching: false,
      };
    }
    case SEND_CODE_REQUEST: {
      return {
        isFetching: true,
      };
    }
    case SEND_CODE_SUCCESSFUL: {
      return {
        isFetching: false,
        isSuccessful: true,
      };
    }
    case SEND_CODE_ERROR: {
      return {
        isFetching: false,
        isSuccessful: false,
      };
    }
    case RESET_PASSWORD_REQUEST: {
      return {
        isFetching: true,
      };
    }
    case RESET_PASSWORD_SUCCESSFUL: {
      return {
        isFetching: false,
        isSuccessful: true,
      };
    }
    case RESET_PASSWORD_ERROR: {
      return {
        isFetching: false,
        isSuccessful: false,
      };
    }
    case SIGNUP_USER_ERROR: {
      return {
        isFetching: false,
        authenticated: false,
        error: action.error,
      };
    }
    default:
      return state;
  }
};
